import React, { useState, useRef, Fragment } from "react";
import {
  Button,
  Paper,
  ButtonGroup,
  Popper,
  Grow,
  ClickAwayListener,
  MenuList,
  MenuItem,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { TranslatedFiles, translatedFileUrl } from "./links";

// 狭い画面では横に並べきれないので、ボタン群を親の幅いっぱいに広げる
const responsiveWidth = { width: { xs: "100%", sm: "auto" } };

interface Props {
  // ダウンロードできる状態のときだけファイルを渡す。
  // 未指定ならボタンは押せない状態で表示される。
  files?: TranslatedFiles;
}

const AltButton = (props: Props) => {
  const [openAlOptions, setOpenAlOptions] = useState(false);
  const anchorRefAlButton = useRef<any>(null);
  const files = props.files;
  const handleToggleAlButton = () => {
    setOpenAlOptions((prevOpen) => !prevOpen);
  };

  const handleCloseAlButton = (event: any) => {
    if (
      anchorRefAlButton.current &&
      anchorRefAlButton.current.contains(event.target)
    ) {
      return;
    }
    setOpenAlOptions(false);
  };
  if (!files) {
    return (
      <ButtonGroup sx={responsiveWidth}>
        <Button variant="contained" disabled sx={{ flexGrow: 1 }}>
          下载中英文交替版 PDF 文件
          <br />
          （用于对比原文）
        </Button>
        <Button size="small" variant="contained" disabled>
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
    );
  }
  return (
    <Fragment>
      <ButtonGroup
        variant="contained"
        ref={anchorRefAlButton}
        aria-label="split button"
        sx={responsiveWidth}
      >
        <Button
          variant="contained"
          sx={{ flexGrow: 1 }}
          onClick={() => {
            window.open(translatedFileUrl(files.alt), "_blank");
          }}
        >
          下载中英文交替版 PDF 文件
          <br />
          （用于对比原文）
        </Button>
        <Button
          size="small"
          aria-controls={openAlOptions ? "split-button-menu" : undefined}
          aria-expanded={openAlOptions ? "true" : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggleAlButton}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 1,
        }}
        open={openAlOptions}
        anchorEl={anchorRefAlButton.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleCloseAlButton}>
                <MenuList id="split-button-menu" autoFocusItem>
                  <MenuItem
                    onClick={() => {
                      window.open(translatedFileUrl(files.print), "_blank");
                    }}
                  >
                    用于打印机的交替版 PDF 文件
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Fragment>
  );
};

export default AltButton;
